module.exports = __webpack_public_path__ + "img/multi-4.4fd5d850.svg";